var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alert pmb-alert" }, [
    _c("div", { staticClass: "time" }, [
      _vm._v(_vm._s(_vm._f("moment")(_vm.alert.time_of_transaction, "HH:mm")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info" }, [
      _c("span", [_vm._v("Table: #" + _vm._s(_vm.alert.table_number))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "price" }, [
      _c("div", { staticClass: "detail" }, [
        _vm._v("£" + _vm._s(_vm._f("total")(_vm.alert.total)))
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "oval",
        attrs: { "data-complete": _vm.isComplete },
        on: {
          click: function($event) {
            _vm.statusChange()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10bb758f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10bb758f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alerts/PMBAlert.vue
// module id = null
// module chunks = 